import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
  * @author Ministerio de cultura
  * @createdate 2024-11-10
  * Metodo que permite crear una validacion personalizada a traves de la comparacion de dos campos y su valores.
  * @param controlName Nombre del input del formulario.
  * @param matchingControlName Nombre del campo con el cual se quiere comparar. 
*/
export function fieldsMatchValidator(controlName: string, matchingControlName: string): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const control = group.get(controlName);
    const matchingControl = group.get(matchingControlName);
    if (!control || !matchingControl) return null;
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ fieldsMismatch: true });
      return { fieldsMismatch: true };
    } else {
      matchingControl.setErrors(null);
      return null;
    }
  };
}